module.exports = __webpack_public_path__ + "1996.svg?399ca191a59a83bb4fdb82765572b2b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1996.svg
// module id = 80
// module chunks = 0